export function FullscreenMessage({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 px-6 text-center text-title">
      <strong>{title}</strong>
      <span className="text-body text-muted">{detail}</span>
    </div>
  );
}
